import React, { useEffect, useState } from 'react';
import './Planning.css';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../../images/planning_bckg.jpg';

const Planning = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    const sections = document.querySelectorAll('.section-content');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="home-container">
      {/* Image de fond fixe */}
      <div className="background-image" style={{ backgroundImage: `url(${backgroundImage})` }}></div>

      {/* Contenu superposé à l'image */}
      <div className="overlay-section">
        <h1 className="overlay-title">
          {t("planning.title")}
        </h1>
      </div>

      <div id="content">
        <div className="section section-1 center">
          <div style={{ maxWidth: 600 }}>
            {/* Titre de la date et lieu */}
            <div className="section-1-title">
              {t("planning.contents.0.title")}
            </div>

            <div className="section-1-text left">
              <p>
                {t("planning.contents.0.label")}
              </p>
            </div>

            <div style={{ marginTop: 20 }}>
              <iframe
                title="Ubicación de la Iglesia"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3076.750763992725!2d3.3320184116197398!3d39.54267617147503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x129646ca0587df45%3A0xd864404c60bd2982!2sEsgl%C3%A9sia%20de%20la%20Mare%20de%20D%C3%A9u%20del%20Carme%20de%20Portocristo!5e0!3m2!1sfr!2sfr!4v1731957794800!5m2!1sfr!2sfr"
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: '10px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
              <button
                className="btn"
                onClick={() => {
                  window.open(
                    "https://www.google.com/maps/dir/?api=1&destination=Plaça+del+Carme,+17,+07680+Porto+Cristo,+Illes+Balears,+Espagne&travelmode=driving",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                {t("planning.buttons.0.label")}
              </button>
            </div>
          </div>
        </div>

        <div className="section section-1 center">
          <div style={{ maxWidth: 600 }}>
            {/* Titre de la date et lieu */}
            <div className="section-1-title">
              {t("planning.contents.1.title")}
            </div>

            {/* Texte descriptif */}
            <div className="section-1-text left">
              <p>
                {t("planning.contents.1.label")}
              </p>
            </div>

            {/* Carte Google Maps */}
            <div style={{ marginTop: 20 }}>
              <iframe
                title="Ubicación de la Iglesia"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3075.1385958846863!2d3.0031233116214597!3d39.57902667146804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1297b664f23d5c8f%3A0x63b3ddf3af28c54a!2sFinca%20Tagamanent!5e0!3m2!1ses!2ses!4v1731946796972!5m2!1ses!2ses"
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: '10px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
              <button
                className="btn"
                onClick={() => {
                  window.open(
                    "https://www.google.com/maps/dir/?api=1&destination=Finca+Tagamanent,+Ctra.+Montu%C3%AFri+-+Sant+Joan,+Km.2,+07230,+Balearic+Islands,+Espa%C3%B1a",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                {t("planning.buttons.0.label")}
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Planning;